module.exports = __webpack_public_path__ + "static/media/videoIcon.b7c7c403.svg";